const jobStatus = {
    DRAFT: 1,
    REVIEW: 2,
    OPEN: 3,
    CLOSED: 4
};

const candidateStatus = {
    DRAFT: 1,
    SUBMIT: 2,
    SEND_INTERVIEW: 3,
    INTERVIEW: 4,
    CANCEL: 5,
    RESCHEDULE: 6, 
    REJECT: 7,
    SEND_TO_OFFER: 8,
    CONTRACT: 9,
    RESCHEDULE_BY_AGENCY: 10,
}

const jobStatusName = {
    DRAFT: "draft",
    REVIEW: "reviews",
    OPEN: "opens",
    CLOSED: "closes"
}

const profiles = {
    AGENCY: "AGENCY",
    CLIENT: "CLIENT"
}

const ROLES = {
    HIRING_MANAGER: "HIRING MANAGER",
    INTERVIEWER: "INTERVIEWER"
}

const STATUS_NOTIFICATION = {
    SEND: 1,
    SEEN: 2
}

const ICON_NOTIFICATION ={
    1: 'account',
    2: 'briefcase',
    3: 'clock-time-five-outline',
    4: 'file-document-outline'
} as { [key: number]: string };


const NOTIFICATION = {
    JOB: 1,
    CANDIDATE: 2,
    INTERVIEW: 3,
    RESULT: 4
}

const ACTION_NOTIFICATION = {
    CREATE_JOB: 1,
    UPDATE_JOB: 2,
    CLOSE_JOB: 3,
    SUBMITTAL: 4,
    INTERVIEW_REQUEST: 5,
    CANDIDATE_REJECT: 6,
    INTERVIEW_REMINDER: 7,
    NEW_INTERVIEW: 8,
    CANCEL_INTERVIEW: 9,
    RESCHEDULE_CLIENT: 10,
    ACCEPT_OFFER: 11,
    NEW_OFFER: 12,
    REVIEW_FEEDBACK: 13,
    DECLINED: 14,
    RESCHEDULE_AGENCY: 15,
    APPROVE_OFFER: 16,
    NEXT_INTERVIEW_REQUEST: 17
}

const senInterviewInviteAction = {
    CLOSE_MODAL: 0,
    SEND_INVITE: 1,
    SEND_MANUAL_INVITE: 2
}

const sendInterviewReviewAction = {
    CLOSE_MODAL: 0,
    SEND_NEXT_INTERVIEW: 1,
    SEND_APPROVED: 2,
    SEND_OFFER: 3,
    SEND_REJECTED: 4
}

export {
    jobStatus, candidateStatus, jobStatusName, profiles, ROLES, NOTIFICATION, STATUS_NOTIFICATION,
    ACTION_NOTIFICATION, ICON_NOTIFICATION, senInterviewInviteAction, sendInterviewReviewAction
};
